import { Box } from '@mui/material';

import { AnnouncementData } from '../../../../../../api/theHive/announcement/types';
import { IconCloseMS } from '../../../../../../constants/icons';
import {
  StyledDialog,
  DialogContainer,
  TextTypography,
  Title,
  CloseButton,
} from './styles';

interface ViewAnnouncementsModalProps {
  isModalOpen: boolean;
  onCloseModal: () => void;
  title: string;
  announcement: AnnouncementData;
}

export function ViewAnnouncementsModal({
  isModalOpen,
  onCloseModal,
  title,
  announcement,
}: ViewAnnouncementsModalProps): JSX.Element {
  return (
    <StyledDialog
      open={isModalOpen}
      onClose={onCloseModal}
      aria-labelledby="announcement dialog"
    >
      <DialogContainer>
        <Box display="flex" justifyContent="space-between">
          <Title>{title}</Title>
          <CloseButton onClick={onCloseModal} disableTouchRipple>
            {IconCloseMS}
          </CloseButton>
        </Box>
        <TextTypography>{announcement.contents}</TextTypography>
      </DialogContainer>
    </StyledDialog>
  );
}
